import React, { useState, useEffect, useRef, memo, useMemo, useCallback, useImperativeHandle } from 'react'
import ChartWrapper from './ChartWrapper'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { mmHgToKPa, celsiusToFahrenheit, percentTommHg, percentToKpa, mmHgToPercent, checkEmptyValue, checkIBPZero, speedStringByType, valueStringByType, isDetectingStringByType, levelStringByType, colorByPriority, getVSMFontSize, getNumericFontSize, getBigBedNumberFontSize, getAlarmStringByType, unitStringByType } from '../plugins/common'
import { useRecoilState, useRecoilValue } from 'recoil';
import { measurementStateFamily, isFromSearchState, wardState, alarmsState, unitState, selectBedInfoState, silenceState, wardSuspendState, wardSilenceState,globalParameterColorState, deviceModelInfo } from '../plugins/recoil';
import axios from '../plugins/axios'
import { useBedData } from '../context/BedDataContext';
import PatientNumeric from './PatientNumeric'
import { getStyles16 } from './PatientNumeric/getNumericStyles'

import {ReactComponent as IconAlarmOff} from '../assets/icons/ic-alarm-suspend.svg'
import {ReactComponent as IconAlarmOn} from '../assets/icons/ic-alarm-on.svg'
import {ReactComponent as IconAlarmSilence} from '../assets/icons/ic-alarm-silence.svg'
import {ReactComponent as IconPrint} from '../assets/icons/ic-print.svg'
import {ReactComponent as IconSetting} from '../assets/icons/ic-setting.svg'
import {ReactComponent as IconNoConnection} from '../assets/icons/ic-no-connection.svg'
import {ReactComponent as IconNoConnectionBlack} from '../assets/icons/ic-no-connection-black.svg'
import {ReactComponent as IconTrend} from '../assets/icons/ic-trend.svg'
import {ReactComponent as IconAlarmReview} from '../assets/icons/ic-alarm-review.svg'
import {ReactComponent as IconShorter} from '../assets/icons/ic-shorter.svg'
import {ReactComponent as IconLonger} from '../assets/icons/ic-longer.svg'
import {ReactComponent as IconClose} from '../assets/icons/ic-close.svg'
import {ReactComponent as IconOneBed} from '../assets/icons/ic-onebed.svg'
import {ReactComponent as IconMeasurements} from '../assets/icons/ic-measurements.svg'
import {ReactComponent as IconAcknowledge} from '../assets/icons/ic-acknowledge.svg'

import AlarmDropdown from './AlarmDropdown'
import useAlarm from './useAlarm';

import './Patient.scss'
const Patient = ({ bedInfo, bedData, viewType, clientHeight, patientCnt, patientIdx, updateHeight, heightChangeValue, handleTrend, handleMeasurements, handleAlarmReview, handleBedSetting, wardStatusChangeFlag, handleClose = null, oneBed = false, handleOpenOneBed,handleStandByConfirm,handlePrint, LeftView
}) => {
    const { t } = useTranslation()
    const [arr, setArr] = useState([0])
    const [dataCountArr, setDataCountArr] = useState([0])
    const [isMouseOver, setIsMouseOver] = useState(false)
    const [height, setHeight] = useState(0)
    const [curWard, ] = useRecoilState(wardState)
    const [isStandbyMode, setIsStandByMode] = useState(false)
    const [vsData, setVsData] = useState({})
    // const [vsDetecting, setVsDetecting] = useState({})
    const [settingStatus, setSettingStatus] = useState({})
    const [outOfRange, setOutOfRange] = useState([])
    const [alarmLimitData, setAlarmLimitData] = useState({})
    const [selectBedInfo, setSelectBedInfo] = useRecoilState(selectBedInfoState)
    const [isFromSearch, setIsFromSearch] = useRecoilState(isFromSearchState)
    const [isDisconnected, setIsDisconnected] = useState(true)
    const [alarms,setAlarms ] = useRecoilState(alarmsState)
    const [measurementSettings, setMeasurementSettings] = useRecoilState(measurementStateFamily(bedInfo.serial))
    const { isAlarmEnabled, alarmActive, handleSilence, handleUnsilence, alarmPriorities, remainingSeconds, isSilenced, unSilenceAll, handleAcknowledge, acknowledgeRemainingSeconds, isAcknowledged, hasUnacknowledgedAlarms, unacknowledgedAlarmsCount, highestUnacknowledgedPriority, getAlarmAcknowledgeStatus, getAcknowledgedTime, clearAlarmState } = useAlarm(bedData, bedInfo);
    const isDisconnectedTimerRef = useRef(null)    
    const highestPriority = alarms[bedInfo.serial]?.length > 0 ? alarms[bedInfo.serial][0].type : null;
    const wardSuspend = useRecoilValue(wardSuspendState);
    const wardSilence = useRecoilValue(wardSilenceState);
    const isWardSuspended = wardSuspend === '1';
    const isWardSilenced = wardSuspend === "2" && wardSilence.isSilenced;// 병동 Silence 여부
    const [isBedNumberBig, setIsNumberBig] = useState(bedInfo.displaySize === 'Large')
    const highIntervalRef = useRef(null)
    const mediumIntervalRef = useRef(null)
    const [highTypes, setHighTypes] = useState([])
    const [mediumTypes, setMediumTypes] = useState([])
    const [lowTypes, setLowTypes] = useState([])
    const [highHighlight, setHighHighlight] = useState(false)
    const [mediumHighlight, setMediumHighlight] = useState(false)
    const highHighlightRef = useRef(highHighlight)
    const mediumHighlightRef = useRef(mediumHighlight)
    const [lowHighlight, setLowHighlight] = useState(false)
    const [units, setUnits] = useRecoilState(unitState)
    const priorityOrder = { 'High': 1, 1: 'High', 'Medium': 2, 2:'Medium', 'Low': 3, 3: 'Low', 'Normal': 4, 4: 'Normal' };
    const [parameterColors, ] = useRecoilState(globalParameterColorState);
    const [isDetecting, setIsDetecting] = useState({ ...isDetectingStringByType })    
    const [deviceModelMenus, ] = useRecoilState(deviceModelInfo);
    const numericObserverRef = useRef(null)
    const [numericPanelContentHeight, setNumericPanelContentHeight] = useState(0)
    const vsmObserverRef = useRef(null)
    const [vsmPanelContentHeight, setVsmPanelContentHeight] = useState(0)
    const { updateBedData } = useBedData()
    const numericPanelRef = useCallback((node) => {
        if (numericObserverRef.current) {
            numericObserverRef.current.disconnect()
        }
        if (node) {
            numericObserverRef.current = new ResizeObserver(() => {
                setNumericPanelContentHeight(node.clientHeight || 0)
            })
            numericObserverRef.current.observe(node)
        } else {
            numericObserverRef.current = null
        }
    }, [])
    const vsmPanelRef = useCallback((node) => {
        if (vsmObserverRef.current) {
            vsmObserverRef.current.disconnect()
        }
        if (node) {
            vsmObserverRef.current = new ResizeObserver(() => {
                setVsmPanelContentHeight(node.clientHeight || 0)
            })
            vsmObserverRef.current.observe(node)
        } else {
            vsmObserverRef.current = null
        }
    }, [])

    const isResizable = (type) => {
        if (typeof bedInfo.bedNumber === 'undefined') return false
        switch(type) {
            case 'longer':
                return clientHeight + heightChangeValue <= (100 - ((patientCnt - 1) * 12.5))
            case 'shorter':
                return clientHeight - heightChangeValue >= 12.5
        }
    }
    
    const renderAlarmIcon = () => {      
        if (bedInfo.suspended || (bedData?.silenceData && (bedData?.silenceData.alarmPause === '1' || bedData?.silenceData.audioPause === '1'))) { // 1) 알람 Off
            if(bedData?.silenceData?.alarmPausePeriod === 'Indefinite'){
                return <IconAlarmOff />;
            }else{
                return <IconAlarmSilence />;
            }
        }
        else if (isWardSilenced || (!isSilenced && bedData?.silenceData && bedData?.silenceData.silenceMode === '1')) { // 2) 병동 Silence
            return <IconAlarmSilence />;
        }
        else if (isWardSuspended) {
            return <IconAlarmOff />
        } else if (isSilenced) { // 3) 개별 침상 Silence
            return (
                <div className="relative w-[28px] h-[28px] flex items-center justify-center cursor-pointer"
                onClick={() => { handleUnsilence(); }}>
                    <IconAlarmSilence />
                    <span
                    className="absolute text-[14px] text-[#DBFF00] font-medium"
                    style={{top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000`}}>
                        {remainingSeconds}
                    </span>
                </div>
            );
        } else {// 4) 알람 On
            return ( <IconAlarmOn onClick={() => { handleSilence()}} /> );
        }
        };

    const isSelectedPatient = () => {
        if (bedInfo || !selectBedInfo || !bedInfo) return false
        if (selectBedInfo.deviceId == bedInfo.deviceId && selectBedInfo.patientId == bedInfo.patientId) return true
    }

    const getAlarmString = (vsType, onlyValue) => {
        const vitalSignType = vsType === 'awRR' ? 'RR' : vsType
        const highAlarmString = getAlarmStringByType(vitalSignType, 'high')
        const lowAlarmString = getAlarmStringByType(vitalSignType, 'low')
        
        if (onlyValue) {
            if (highAlarmString) return checkEmptyValue(settingStatus[highAlarmString])
            else return '---'
        }

        if (highAlarmString || lowAlarmString) {
            if (['NIBPSYS', 'NIBPDIA', 'NIBPMEAN', 'IBP1SYS', 'IBP1DIA', 'IBP1MEAN', 'IBP2SYS', 'IBP2DIA', 'IBP2MEAN', 'IBP3SYS', 'IBP3DIA', 'IBP3MEAN', 'IBP4SYS', 'IBP4DIA', 'IBP4MEAN', 'EtCO2', 'InCO2', 'Temp1', 'Temp2'].indexOf(vsType) !== -1) {
                const vsTypeText = vsType.replace('SYS', '').replace('DIA', '').replace('MEAN', '')
                if (units[vsTypeText] === 'kPa') {
                    return `${checkEmptyValue(mmHgToKPa(settingStatus[highAlarmString]))}/${checkEmptyValue(mmHgToKPa(settingStatus[lowAlarmString]))}`
                } else if (units[vsTypeText] === '%') {
                    return `${checkEmptyValue(mmHgToPercent(settingStatus[highAlarmString]))}/${checkEmptyValue(mmHgToPercent(settingStatus[lowAlarmString]))}`
                } else if (units[vsTypeText] === '°F') {
                    return `${checkEmptyValue(celsiusToFahrenheit(settingStatus[highAlarmString]))}/${checkEmptyValue(celsiusToFahrenheit(settingStatus[lowAlarmString]))}`
                } else if (units[vsTypeText] === '°C') {
                    return `${checkEmptyValue(settingStatus[highAlarmString]?.toFixed(1))}/${checkEmptyValue(settingStatus[lowAlarmString]?.toFixed(1))}`
                } else {
                    return `${checkEmptyValue(settingStatus[highAlarmString])}/${checkEmptyValue(settingStatus[lowAlarmString])}`
                }
            } else {
                return `${checkEmptyValue(settingStatus[highAlarmString])}/${checkEmptyValue(settingStatus[lowAlarmString])}`
            }
        } else {
            return `-/-`
        }
    }

    const handleBtn = (btnType) => {
        if (typeof bedInfo.bedNumber === 'undefined') return
        setSelectBedInfo(bedInfo)
        setIsFromSearch(false)     
        switch(btnType) {
            case 'trend':
                handleTrend('open')
                break;
            case 'measurements':
                handleMeasurements('open')
                break;
            case 'setting':
                handleBedSetting('open')
                break;
            case 'alarm':
                handleAlarmReview('open')
                break;
            case 'oneBed':
                handleOpenOneBed('open',patientIdx)
                break;
            case 'print':
                handlePrint(bedInfo)
                break;
        }
    }

    const handleUpdateDataCount = (idx, val) => {
        const newDataCountArr = [...dataCountArr]
        newDataCountArr[idx] = val
        setDataCountArr(newDataCountArr)
    }

    const getNIBPDiff = () => {
        if (!settingStatus.lastBPMonth || !settingStatus.lastBPDay) return '---'
        let nibpTime = moment()
                .set('month', settingStatus.lastBPMonth - 1)
                .set('date', settingStatus.lastBPDay)
                .set('hour', settingStatus.lastBPHour)
                .set('minute', settingStatus.lastBPMinute)
        while(nibpTime.isAfter(moment())) {
            nibpTime = nibpTime.subtract(1, 'year')
        }
        const diffTime = moment().diff(nibpTime)
        const duration = moment.duration(diffTime)
        const totalMinutes = Math.floor(duration.asMinutes())
        const hrs = Math.floor(totalMinutes / 60)
        const mins = totalMinutes % 60

        return isDisconnected ? '---' : `${hrs.toString().length > 1 ? hrs : '0' + hrs}:${mins.toString().length > 1 ? mins : '0' + mins}`
    }

    // Device 별 Menu 렌더링
    const renderMenus = () => {        
        const modelInfo = deviceModelMenus.find(item => item.model === bedInfo.deviceModel);             
        const menus = [];            

        if (modelInfo.trendSupported) {
            menus.push(
                <div key={`trend-${bedInfo.serial}`} onClick={() => { handleBtn('trend') }} className="flex items-center justify-center text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                    <IconTrend className=""/>
                </div>
            );
        }
        if (modelInfo.alarmReviewSupported) {
            menus.push(
                <div key={`alarm-${bedInfo.serial}`} onClick={() => { handleBtn('alarm') }} className="flex items-center justify-center gap-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                    <IconAlarmReview className=""/>
                </div>
            );
        }
        if (modelInfo.nibpSupported) {
            menus.push(
                <div key={`measurements-${bedInfo.serial}`} onClick={() => { handleBtn('measurements') }} className="flex items-center justify-center gap-1 text-white cursor-pointer">
                    <IconMeasurements className=""/>
                </div>
            );
        }        
        if(modelInfo.printSupported){
            menus.push(
                <div key={`print-${bedInfo.serial}`} onClick={() => { handleBtn('print') }} className="flex items-center justify-center gap-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                    <IconPrint className=""/>
                </div> 
            );
        }
        if (modelInfo.bedSettingSupported) {
            menus.push(
                <div key={`setting-${bedInfo.serial}`} onClick={() => { handleBtn('setting') }} className="flex items-center justify-center gap-1 text-white cursor-pointer">
                    <IconSetting className=""/>
                </div>
            );
        }

        return menus;
    }

    useEffect(() => {
        if (wardStatusChangeFlag) {
            if (wardSuspend == '0') {
                unSilenceAll()
            }
        }
    }, [wardStatusChangeFlag])

    useEffect(() => {
        setHeight(clientHeight)
    }, [clientHeight])

    useEffect(() => {
        setIsNumberBig(bedInfo.displaySize === 'Large')        
        // setIsStandByMode(bedInfo.standbyMode) //StandBy 모드 여부
        const speedSettings = bedInfo.waveSettings?.map(ws => { return { parameter: ws.measureParameter, speed: ws.swapSpeed } })
        if (speedSettings) {
            const newMeasurementSettings = { ...measurementSettings }
            speedSettings.forEach(ss => {
                if (ss.parameter && speedStringByType[ss.parameter]) {
                    newMeasurementSettings[speedStringByType[ss.parameter]] = ss.speed
                }
            })
            setMeasurementSettings(newMeasurementSettings)
        }
        const filteredWaveCodeList = bedInfo.waveCodeList ? bedInfo.waveCodeList.filter(item => item !== 'NONE') : null
        setArr(['LEADⅡ'])
        setDataCountArr(Array(filteredWaveCodeList ? 1 : 0))
    }, [bedInfo, viewType])

    useEffect(() => {        
        if (bedData) {
            const newBedData = {
                numericData: bedData.numericData ? { ...bedData.numericData } : {},
                waveData: bedData.waveData ? { ...bedData.waveData } : {},
                settingData: bedData.settingData ? { ...bedData.settingData } : {}
                // outOfRange: []
            }
            const ibpTypeValueStringArr = [];
            ['NIBP', 'IBP1', 'IBP2', 'IBP3', 'IBP4'].forEach((typeKey) => {
                ibpTypeValueStringArr.push(...[`${typeKey.toLowerCase()}DiaValue`, `${typeKey.toLowerCase()}SysValue`, `${typeKey.toLowerCase()}MapValue`])
            })            

            Object.keys(bedData.numericData || {}).forEach(key => {
                // IBP일때는 0이거나 값이 없을때만 값 세팅
                if (ibpTypeValueStringArr.indexOf(key) !== -1 && (!newBedData.numericData[key])) {
                    newBedData.numericData[key] = bedData.numericData[key]
                } else {
                    newBedData.numericData[key] = bedData.numericData[key]
                }
            })

            if (bedData.outOfRangeData?.length > 0) {
                const newOutOfRange = []
                const outOfRangeSeries = ['HR', 'SpO2', 'RESP', 'IBP1', 'IBP2', 'IBP3', 'IBP4', 'Co2', 'GAS', 'Temp1', 'Temp2']
                const outOfRangeTypes = bedData.outOfRangeData.map((item) => item.alarmType)
                outOfRangeTypes.forEach((item) => {
                    if (item === 'ECG') { newOutOfRange.push('HR', 'PR')}
                    else if (item === 'SPO2') { newOutOfRange.push('SpO2', 'PR')}
                    else if (item === 'CO2') { newOutOfRange.push('EtCO2', 'InCO2', 'IPI') }
                    else if (item === 'TEMP1') { newOutOfRange.push('Temp1') }
                    else if (item === 'TEMP2') { newOutOfRange.push('Temp2') }
                    else { newOutOfRange.push(item) }
                })
                setOutOfRange(newOutOfRange)
            } else {
                setOutOfRange([])
            }

            const bpSeries = ['NIBP', 'IBP1', 'IBP2', 'IBP3', 'IBP4']
            bpSeries.forEach((item) => {
                if (units[item] === 'kPa') {
                    newBedData.numericData[`${item.toLowerCase()}SysValue`] = mmHgToKPa(newBedData.numericData[`${item.toLowerCase()}SysValue`])
                    newBedData.numericData[`${item.toLowerCase()}DiaValue`] = mmHgToKPa(newBedData.numericData[`${item.toLowerCase()}DiaValue`])
                    newBedData.numericData[`${item.toLowerCase()}MapValue`] = mmHgToKPa(newBedData.numericData[`${item.toLowerCase()}MapValue`])
                }
            })            

            const co2Series = ['EtCO2', 'InCO2']
            co2Series.forEach((item) => {
                if (units[item] === 'kPa') {
                    newBedData.numericData[valueStringByType[item]] = mmHgToKPa(newBedData.numericData[valueStringByType[item]])
                }else if (units[item] === '%') {
                    newBedData.numericData[valueStringByType[item]] = mmHgToPercent(newBedData.numericData[valueStringByType[item]])
                }
            })

            const tempSeries = ['Temp1', 'Temp2']
            tempSeries.forEach(item => {
                if (units[item] === '°F') {
                    newBedData.numericData[valueStringByType[item]] = celsiusToFahrenheit(newBedData.numericData[valueStringByType[item]])
                } else {
                    if (isNaN(parseFloat(newBedData.numericData[valueStringByType[item]])?.toFixed(1))) {
                        newBedData.numericData[valueStringByType[item]] = null
                    } else {
                        newBedData.numericData[valueStringByType[item]] = parseFloat(newBedData.numericData[valueStringByType[item]])?.toFixed(1)
                    }
                }
            })

            if (units['GAS'] === 'mmHg') {
                newBedData.numericData[valueStringByType['GasO2Ex']] = percentTommHg(newBedData.numericData[valueStringByType['GasO2Ex']])
                newBedData.numericData[valueStringByType['GasO2In']] = percentTommHg(newBedData.numericData[valueStringByType['GasO2In']])
                newBedData.numericData[valueStringByType['GasCo2Ex']] = percentTommHg(newBedData.numericData[valueStringByType['GasCo2Ex']])
                newBedData.numericData[valueStringByType['GasCo2In']] = percentTommHg(newBedData.numericData[valueStringByType['GasCo2In']])
                newBedData.numericData[valueStringByType['GasSevEx']] = percentTommHg(newBedData.numericData[valueStringByType['GasSevEx']])
                newBedData.numericData[valueStringByType['GasSevIn']] = percentTommHg(newBedData.numericData[valueStringByType['GasSevIn']])
                newBedData.numericData[valueStringByType['GasDesEx']] = percentTommHg(newBedData.numericData[valueStringByType['GasDesEx']])
                newBedData.numericData[valueStringByType['GasDesIn']] = percentTommHg(newBedData.numericData[valueStringByType['GasDesIn']])
                newBedData.numericData[valueStringByType['GasN2OEx']] = percentTommHg(newBedData.numericData[valueStringByType['GasN2OEx']])
                newBedData.numericData[valueStringByType['GasN2OIn']] = percentTommHg(newBedData.numericData[valueStringByType['GasN2OIn']])
            } else if (units['GAS'] === 'kPa') {
                newBedData.numericData[valueStringByType['GasO2Ex']] = percentToKpa(newBedData.numericData[valueStringByType['GasO2Ex']])
                newBedData.numericData[valueStringByType['GasO2In']] = percentToKpa(newBedData.numericData[valueStringByType['GasO2In']])
                newBedData.numericData[valueStringByType['GasCo2Ex']] = percentToKpa(newBedData.numericData[valueStringByType['GasCo2Ex']])
                newBedData.numericData[valueStringByType['GasCo2In']] = percentToKpa(newBedData.numericData[valueStringByType['GasCo2In']])
                newBedData.numericData[valueStringByType['GasSevEx']] = percentToKpa(newBedData.numericData[valueStringByType['GasSevEx']])
                newBedData.numericData[valueStringByType['GasSevIn']] = percentToKpa(newBedData.numericData[valueStringByType['GasSevIn']])
                newBedData.numericData[valueStringByType['GasDesEx']] = percentToKpa(newBedData.numericData[valueStringByType['GasDesEx']])
                newBedData.numericData[valueStringByType['GasDesIn']] = percentToKpa(newBedData.numericData[valueStringByType['GasDesIn']])
                newBedData.numericData[valueStringByType['GasN2OEx']] = percentToKpa(newBedData.numericData[valueStringByType['GasN2OEx']])
                newBedData.numericData[valueStringByType['GasN2OIn']] = percentToKpa(newBedData.numericData[valueStringByType['GasN2OIn']])
            }

            //RR 측정 On인 경우에만 
            if(newBedData.settingData.rrOnOff){
                if (newBedData.numericData.rrSource === 'Impedance') { // ECG로 되어있으면 무조건 '-'
                    newBedData.numericData[valueStringByType['awRR']] = '-'
                } else {
                    newBedData.numericData[valueStringByType['RR']] = '-'
                    newBedData.numericData[valueStringByType['RESP']] = '-'
                }

                if (newBedData.numericData.rrSource === 'Airway') {
                    setIsDetecting(prev => ({ ...prev, 'awRR': 'co2Measurement' }))
                    newBedData.numericData[valueStringByType['awRR']] = newBedData.numericData.co2Measurement ? newBedData.numericData.etCO2RRValue : '-'
                } 
                if (newBedData.numericData.rrSource === 'Airway2 (from Gas)') {
                    setIsDetecting(prev => ({ ...prev, 'awRR': 'gasCO2Measurement' }))
                    newBedData.numericData[valueStringByType['awRR']] = newBedData.numericData.gasCO2Measurement ? newBedData.numericData.gasRRValue : '-'
                }
            }
            
            setIsDetecting(prev => ({ ...prev, 'PR': `${newBedData.numericData.hrprSource?.toLowerCase()}Measurement` }))
            if (newBedData.numericData.hrprSource === 'ECG') {
                newBedData.numericData[valueStringByType['PR']] = newBedData.numericData.hrValue 
            } else if (['SpO2', 'IBP1', 'IBP2', 'IBP3', 'IBP4', 'NIBP'].includes(newBedData.numericData.hrprSource)) {
                if (['IBP1', 'IBP2', 'IBP3', 'IBP4'].includes(newBedData.numericData.hrprSource)) {
                    if (['PAP', 'ICP', 'CVP', 'RAP', 'LAP', 'UVP', 'IC1', 'IC2'].includes(newBedData.settingData[`${newBedData.numericData.hrprSource.toLowerCase()}Label`])) {
                        newBedData.numericData[valueStringByType['PR']] = '-'
                    } else {
                        newBedData.numericData[valueStringByType['PR']] = newBedData.numericData[`${newBedData.numericData.hrprSource.toLowerCase()}PulseRate`] 
                    }
                } else {
                    newBedData.numericData[valueStringByType['PR']] = newBedData.numericData[`${newBedData.numericData.hrprSource.toLowerCase()}PulseRate`] 
                    if (newBedData.numericData.hrprSource === 'NIBP') {
                        newBedData.numericData.nibpMeasurement = !(checkIBPZero(newBedData.numericData.nibpSysValue, '', '', true) === '-' && checkIBPZero(newBedData.numericData.nibpDiaValue, '', '', true) === '-' && checkIBPZero(newBedData.numericData.nibpMapValue, '', '', true) === '-')
                    }
                }
            }
            
            setMeasurementSettings(prev => {
                return {
                    ...prev,
                    intervalSeconds: newBedData.settingData?.measurementIntervalSeconds || prev.intervalSeconds,
                }
            })
            setSettingStatus(newBedData.settingData)   
            setVsData(newBedData.numericData)
            setIsStandByMode(bedData.silenceData?.standbyMode == '1')

            //console.log('bedInfo', bedInfo);
            if (bedInfo.serial == '867376000') {
                // console.log(bedData.outOfRangeData)
                // console.log(bedData.numericData)
                // console.log('SETTINGS : ',bedData)
                // console.log(newBedData.numericData)
                // console.log(bedData.alarmData)
                // console.log(bedData)
                // console.log(bedData.settingData)
            }
            if (bedInfo.serial == '000000000000') {
                // console.log(bedData.numericData)
                // console.log(bedData.settingData)
            }
            //데이터 있을 경우에만 false
            setIsDisconnected(false)   
        }
        
        if (isDisconnectedTimerRef.current) {
            clearTimeout(isDisconnectedTimerRef.current)
            isDisconnectedTimerRef.current = null
        }        

        //V20 모델은 Disconnected Timer 미적용        
        if(bedInfo.deviceModel == 'V20'){            
            setIsDisconnected(false)
        }else{
            isDisconnectedTimerRef.current = setTimeout(() => {
                setIsDisconnected(true)
                setVsData({})
                setSettingStatus({})
                setAlarmLimitData({})  
                clearAlarmState(); // disconnect 시 알람 상태 초기화
                
                // Rodney - disconnect후 reconnect 됐을 때 끊기기 전 알람이 남아있어서 아예 데이터 날려버리고 다시 받기 위해 삭제함.
                // bedDataRecoil에서 해당 serial 데이터 제거
                updateBedData(prev => {
                    if (!prev || !prev[bedInfo.serial]) return prev;
                    const newData = { ...prev };
                    delete newData[bedInfo.serial];
                    return newData;
                });
            }, 10000)
        }
    }, [bedData])

    useEffect(() => {
        return () => {
            if (isDisconnectedTimerRef.current) {
                clearTimeout(isDisconnectedTimerRef.current)
            }
            if (numericObserverRef.current) {
                numericObserverRef.current.disconnect()
            }
            if (vsmObserverRef.current) {
                vsmObserverRef.current.disconnect()
            }
        }
    }, [])

    const getAdaptiveFontSize = (value, baseVal = 50) => {
        const valueStr = String(value || '');
        const length = valueStr.length;
        
        let fontSize = baseVal;

        if (length > 2) {
            fontSize = Math.max(20, baseVal - (length - 2) * 3);
        }
        return fontSize;
    };

    const vsmRows = useMemo(() => {
        const defaultRows = viewType >= 12 ? 1 : 2

        if (!vsmPanelContentHeight || defaultRows === 1) return defaultRows

        const MIN_ROW_HEIGHT = 80
        const maxRows = Math.floor(vsmPanelContentHeight / MIN_ROW_HEIGHT)

        if (maxRows >= 2) return 2
        return 1
    }, [viewType, vsmPanelContentHeight])

    const numericStyles = useMemo(
        () => getStyles16({ viewType, oneBed, isBedNumberBig, isVSM: false }),
        [viewType, oneBed, isBedNumberBig]
    )

    const getAlarmStringCb = useCallback((vsType) => getAlarmString(vsType), [settingStatus, units])
    const getNIBPDiffCb = useCallback(() => getNIBPDiff(), [settingStatus, isDisconnected])

    const commonProps = useMemo(() => ({
        vsData, settingStatus, outOfRange, units, isDetecting, parameterColors,
        getAlarmStringFn: getAlarmStringCb,
        getNIBPDiff: getNIBPDiffCb,
        getAdaptiveFontSize,
    }), [vsData, settingStatus, outOfRange, units, isDetecting, parameterColors, getAlarmStringCb, getNIBPDiffCb])
    
    return (
        <div className={`relative flex flex-grow ${isSelectedPatient() ? 'selected-patient' : ''}`} style={{ backgroundColor: (!isDisconnected && !isStandbyMode && alarms[bedInfo.serial]?.length > 0 && hasUnacknowledgedAlarms) ? '#02008B' : 'black', width: '100%', maxHeight: `${100 - ((patientCnt - 1) * 12.5)}%`, minHeight: '12.5%', height: `${height}%`, borderTopWidth: `${oneBed ? '0px' : '1.5px'}`, borderLeftWidth: `${oneBed ? '0px' : LeftView ? '1.5px' : '0px'}`, borderRightWidth: `${oneBed ? '0px' : '1.5px'}`,  borderBottomWidth: (patientIdx === patientCnt - 1) ? 1.5 : 0, borderColor: '#fff'}} onMouseEnter={(e) => { setIsMouseOver(true) }} onMouseLeave={() => { setIsMouseOver(false) }}>
            {
                bedInfo.serial &&             
                isBedNumberBig &&
                <div className="flex items-center justify-center text-center text-white break-all whitespace-nowrap" style={{ ...getBigBedNumberFontSize(viewType), minWidth: 178, maxWidth: 178, background: isDisconnected ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), linear-gradient(180deg, #FF002E 0%, #99001C 100%)' : 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)' }}>
                    {checkEmptyValue(bedInfo.bedNumber.length <= 1 ? `0${bedInfo.bedNumber}` : bedInfo.bedNumber, `${t('dashboard.bedName')}-`)}
                </div>
            }
            {
                bedInfo.serial &&
                <div className="flex flex-col flex-grow" style={{ height: '100%', maxWidth: (isStandbyMode) ? '100%' : bedInfo.vsmMode ? (oneBed ? '100%' : isBedNumberBig ? 'calc(100% - 178px)' : '100%') : oneBed ? 'calc(100% - 804px)' : isBedNumberBig ? 'calc(100% - 402px)' : 'calc(100% - 224px)' }} >
                    <div className="flex items-center" style={{ height: 32 }}>
                        {
                            !isBedNumberBig &&
                            <div className="flex items-center justify-center h-full text-white" style={{ fontWeight: 500, fontSize: 24, lineHeight: '24px', minWidth: 178, maxWidth: 178, background: isDisconnected ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), linear-gradient(180deg, #FF002E 0%, #99001C 100%)' : 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)' }}>
                                {checkEmptyValue(bedInfo.bedNumber.length <= 1 ? `0${bedInfo.bedNumber}` : bedInfo.bedNumber, `${t('dashboard.bedName')}-`)}
                            </div>
                        }
                        <div className="flex items-center" style={{ width: isBedNumberBig ? '100%' : 'calc(100% - 178px)' }}>
                            {
                                bedInfo.serial &&
                                !isStandbyMode && 
                                <div className="flex items-center">
                                    {!isDisconnected && (
                                        <>
                                            <div className="cursor-pointer" style={{ width: 28, height: 28 }}>
                                            {renderAlarmIcon()}
                                            </div>
                                        </>
                                    )}
                                    {
                                        isDisconnected &&
                                        <div className="ml-1"  style={{ color: 'white', width: 28, height: 28,}}> 
                                            {
                                                isSelectedPatient() ?
                                                <IconNoConnectionBlack /> :
                                                <IconNoConnection />
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                bedInfo.serial &&
                                <>
                                    <div className="relative flex items-center flex-1 text-white truncate" style={{ marginLeft: isStandbyMode ? 5 : 0, maxWidth: bedInfo.vsmMode ? ((!isDisconnected && !isStandbyMode && hasUnacknowledgedAlarms && isMouseOver) ? 'calc(100% - 476px - 90px)' : 'calc(100% - 476px)') : ((!isDisconnected && !isStandbyMode && hasUnacknowledgedAlarms && isMouseOver) ? 'calc(100% - 28px - 88px)' : 'calc(100% - 28px)'), fontSize: 16, fontWeight: '17.6px', fontWeight: 200 }} title={isDisconnected ? '-' : bedInfo.nameDisplay === '1' ? checkEmptyValue(bedInfo.patientName) : bedInfo.nameDisplay === '2' ? checkEmptyValue(bedInfo.devicePatientId) : bedInfo.nameDisplay === '3' ? `${checkEmptyValue(bedInfo.patientName)},${checkEmptyValue(bedInfo.devicePatientId)}` : '-'}>
                                        {!bedInfo.devicePatientId ? t('dashboard.notAdmitted') : (bedInfo.nameDisplay === '1' ? checkEmptyValue(bedInfo.patientName) : bedInfo.nameDisplay === '2' ? checkEmptyValue(bedInfo.devicePatientId) : bedInfo.nameDisplay === '3' ? `${checkEmptyValue(bedInfo.patientName)} , ${checkEmptyValue(bedInfo.devicePatientId)}` : '-')}
                                        <div className="bg-[#1F1F1F] rounded-[6px] ml-2 bg-gradient-to-b from-[#5E5E5E] to-[#383838]" style={{ maxWidth: 120, padding: '2.5px 6px', border: '1px solid #5E5E5E' }}>{checkEmptyValue(bedInfo.serial)}</div>
                                    </div>
                                </>
                            }
                            {
                                !isDisconnected && !isStandbyMode && hasUnacknowledgedAlarms && isMouseOver &&
                                <div className="flex items-center justify-center gap-[10px] mr-[2px] cursor-pointer" onClick={() => { handleAcknowledge() }} style={{ boxShadow: '0px 2px 6px 0px #00000099', borderRadius: 6, background: 'linear-gradient(180deg, #FFED66 0%, #E9C300 100%)', borderImageSource: 'linear-gradient(180deg, #FFFFFF 0%, #FFF6B5 11.54%, #FFF290 100%)', minWidth: 88, maxWidth: 88, minHeight: 32, maxHeight: 32 }}>
                                    <IconAcknowledge />
                                    <span className="text-black" style={{ fontSize: 18 }}>{unacknowledgedAlarmsCount}</span>
                                </div>
                            }
                            { bedInfo.vsmMode && !isDisconnected && !isStandbyMode && alarms[bedInfo.serial]?.length > 0 && <div className='flex-1 ml-auto' style={{ minWidth: 224, maxWidth: 224, minHeight: 32, maxHeight: 32, marginRight: oneBed ? 35 : 0}}>
                                <AlarmDropdown
                                    isOneBed={oneBed}
                                    options={alarms[bedInfo.serial] || []}
                                    priority={highestPriority}
                                    placeholder="알람 선택"
                                    isAcknowledged={isAcknowledged}
                                    acknowledgeRemainingSeconds={acknowledgeRemainingSeconds}
                                    getAlarmAcknowledgeStatus={getAlarmAcknowledgeStatus}
                                />
                            </div>}                            
                            {
                                bedInfo.vsmMode && !isDisconnected && !isStandbyMode && oneBed && (
                                    <div className='absolute top-0 right-0'>
                                        <IconClose onClick={handleClose} className=" m-[10px] cursor-pointer "/>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    {
                        isStandbyMode ?
                        // <div onClick={() => { handleClickStandby() }} className="flex flex-col items-center justify-center text-[#FFA800] cursor-pointer" style={{ height: 'calc(100% - 32px)' }}>
                        <div onClick={() => { handleStandByConfirm(bedInfo.deviceId) }} className="flex flex-col items-center justify-center text-[#FFA800] cursor-pointer" style={{ height: 'calc(100% - 32px)' }}>
                            <span className="" style={{ fontWeight: 600, fontSize: 48, lineHeight: '48px' }}>{t('dashboard.standBy')}</span>
                            <span className="mt-2" style={{ fontWeight: 300, fontSize: 16, lineHeight: '16px' }}>{t('dashboard.disableStandByMessage')}</span>
                        </div> :
                        <div className="relative flex items-center" style={{ height: 'calc(100% - 32px)'}}>
                            <div className="w-full h-full" style={{ maxHeight: 150 }}>
                                {
                                    !bedInfo.vsmMode &&
                                    arr.map((node, idx) => {
                                        let isDetectingValue = typeof vsData[isDetecting[node]] === 'undefined' ? true : vsData[isDetecting[node]]
                                        return (
                                            <ChartWrapper 
                                                key={`chart-item-${node}`}
                                                isFirst={idx === 0}
                                                isDisconnected={isDisconnected}
                                                isBedNumberBig={isBedNumberBig}
                                                isDetecting={isDetectingValue}
                                                isShowECGPacer={true}
                                                settingStatus={settingStatus}
                                                type={node}
                                                data={bedData ? bedData.waveData || {} : {}}
                                                bedInfo={bedInfo}
                                                hideType={true}
                                                chartCount={arr.length}
                                                viewType={viewType}
                                                handleBufferCount={(bufferCnt) => { handleUpdateDataCount(idx, bufferCnt) }}
                                            />
                                        )
                                    })
                                }
                            </div>
                            {
                                !isDisconnected &&
                                // bedInfo.patientId &&
                                bedInfo.deviceId &&
                                bedInfo.serial &&
                                isMouseOver &&                                
                                <div className="absolute flex bg-gradient-to-b from-[#5E5E5E] to-[#1F1F1F]" style={{ top: 4, left: 4, borderRadius: 6 }}>                                    
                                    {renderMenus()}
                                    {
                                        <>
                                            <div onClick={() => { isResizable('longer') && updateHeight(patientIdx, 'plus') }} className="flex items-center justify-center gap-1 text-white cursor-pointer" style={{ opacity: isResizable('longer') ? 1 : 0.4, width: 28, height: 28 }}>
                                                <IconLonger className=""/>
                                            </div>
                                            <div onClick={() => { isResizable('shorter') && updateHeight(patientIdx, 'minus') }} className="flex items-center justify-center text-white cursor-pointer" style={{ opacity: isResizable('shorter') ? 1 : 0.4, width: 28, height: 28 }}>
                                                <IconShorter className=""/>
                                            </div>
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            }
            {
                !isStandbyMode &&
                bedInfo.serial &&
                !bedInfo.vsmMode &&
                <div ref={numericPanelRef} className="relative flex" style={{ paddingTop: (oneBed ? 0 : (!isDisconnected && alarms[bedInfo.serial]?.length) > 0 ? 0 : 32), flexDirection: 'column', height: '100%', borderRightWidth: 1, borderColor: 'black', minWidth: `${oneBed ? '802px' : '224px' }`, maxWidth: `${oneBed ? '802px' : '224px' }` }}>
                    {
                        oneBed ? (
                            <div className='relative flex-1 pr-10' style={{ minHeight: 32, maxHeight: 32 }}>
                                {
                                    !isDisconnected && !isStandbyMode && alarms[bedInfo.serial]?.length > 0  &&  <div className='flex-1' style={{ minHeight: 32, maxHeight: 32 }}>
                                        <AlarmDropdown
                                            isOneBed={oneBed}
                                            options={alarms[bedInfo.serial] || []}
                                            priority={highestPriority}
                                            placeholder="알람 선택"
                                            isAcknowledged={isAcknowledged}
                                            acknowledgeRemainingSeconds={acknowledgeRemainingSeconds}
                                            getAlarmAcknowledgeStatus={getAlarmAcknowledgeStatus}
                                        />
                                    </div>
                                }
                                <div className='absolute top-0 right-0'>
                                    <IconClose onClick={handleClose} className=" m-[10px] cursor-pointer "/>
                                </div>
                            </div>     
                        ) : (
                            !isDisconnected && !isStandbyMode && alarms[bedInfo.serial]?.length > 0 &&  
                            <div className='flex-1' style={{ minHeight: 32, maxHeight: 32 }}>
                                <AlarmDropdown
                                    isOneBed={oneBed}
                                    options={alarms[bedInfo.serial] || []}
                                    priority={highestPriority}
                                    placeholder="알람 선택"
                                    isAcknowledged={isAcknowledged}
                                    acknowledgeRemainingSeconds={acknowledgeRemainingSeconds}
                                    getAlarmAcknowledgeStatus={getAlarmAcknowledgeStatus}
                                />
                            </div>
                        )
                    }
                    <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    {
                        <>
                            <div className="flex flex-1" style={{ borderTopWidth: 1, borderBottomWidth: 1, borderColor: '#383838', height: 'calc(50% - 16px)' }}>
                                <PatientNumeric
                                    isLeft={true}
                                    styles={numericStyles}
                                    type={'HR'}
                                    alarmString={getAlarmString('HR')}
                                    {...commonProps}
                                />
                            </div>
                            <div className="flex flex-1" style={{ borderBottomWidth: 1, borderColor: '#383838', height: 'calc(50% - 16px)' }}>
                                <div className="flex h-full items-center flex-1 px-1" style={{ fontFamily: 'Roboto', color: parameterColors.numericParameterColors['HR'], borderLeftWidth: 1, borderRightWidth: 1, borderColor: '#383838' }}>
                                    <div className="flex flex-col h-full flex-1">
                                        <div className="flex items-center w-full flex-1">
                                            <div className="" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`Tachycardia`}</div>
                                            <div className="ml-auto" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`0`}</div>
                                        </div>
                                        <div className="flex items-center w-full flex-1">
                                            <div className="" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`VT`}</div>
                                            <div className="ml-auto" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`0`}</div>
                                        </div>
                                        <div className="flex items-center w-full flex-1">
                                            <div className="" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`Bradycardia`}</div>
                                            <div className="ml-auto" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`0`}</div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col h-full flex-1 ml-4">
                                        <div className="flex items-center w-full flex-1">
                                            <div className="" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`SVT`}</div>
                                            <div className="ml-auto" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`0`}</div>
                                        </div>
                                        <div className="flex items-center w-full flex-1">
                                            <div className="" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`Pause`}</div>
                                            <div className="ml-auto" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`0`}</div>
                                        </div>
                                        <div className="flex items-center w-full flex-1">
                                            <div className="" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`AFib`}</div>
                                            <div className="ml-auto" style={{ ...getNumericFontSize(viewType, viewType >= 12 ? 'gasValue' : 'alarmString') }}>{`0`}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    </div>
                </div>
            }
            {
                !bedInfo.serial && (          
                    <>
                        {
                            oneBed && 
                            <div>
                                <IconClose onClick={handleClose} className="absolute top-0 right-0 m-[10px] cursor-pointer "/>
                            </div>
                        }
                        <div className="flex items-center justify-center text-[#9F9F9F]" style={{ height: '100%', width: '100%' }}>
                            <span className="" style={{ fontWeight: 300, fontSize: 16, lineHeight: '17.6px' }}>{t('dashboard.emptyBedMessage')}</span>
                        </div>
                    </>          
                    
                )
            }
        </div>
    )
}

export default Patient